import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  FetchContactEmailsFromApolloResponseType,
  GetContactsByCompanyIdResponseType,
} from "@src/resources/contacts/contacts.service";

const c = initContract();

const GetContactsByCompanyIdSchema = z.object({
  companyIds: z.string().array(),
  hasAttendedConference: z.boolean().optional(),
  hasVerifiedEmail: z.boolean().optional(),
  jobTitles: z.string().array().optional(),
  keywords: z.string().array().optional(),
  locations: z.string().array().optional(),
  page: z.number().optional(),
  pageSize: z.number().optional(),
});

export type GetContactsByCompanyIdSchemaType = z.infer<typeof GetContactsByCompanyIdSchema>;

const index = c.router({
  getContactEmails: {
    body: z.object({
      peopleIds: z.string().array(),
    }),
    method: "POST",
    path: "/contacts/get-contact-emails",
    responses: {
      200: c.type<FetchContactEmailsFromApolloResponseType>(),
    },
  },
  getContactsByCompanyIds: {
    body: GetContactsByCompanyIdSchema,
    method: "POST",
    path: "/contacts/get-contacts-by-company-ids",
    responses: {
      200: c.type<GetContactsByCompanyIdResponseType>(),
    },
  },
});

export default index;
